'use strict';
const { createAddQueries } = require('../addQueries');
const { modelP2pPayment } = require('../../datatypes');
const {
  id,
  payerId,
  userId,
  payeeId,
  microService,
  transaction: {
    deliver,
    status,
    foreverOffOn,
    frequency,
  },
} = require('./commons');

module.exports = createAddQueries({
  baseUrl: ({ fspId }) => `/fsps/${fspId}/modelp2ppayments`,
  returnModel: {
    name: 'modelp2ppayment',
    model: modelP2pPayment,
  },
  finders: [
    id,
    userId,
    payerId,
    payeeId,
    status,
    microService,
    foreverOffOn,
    deliver,
    frequency,
  ],
  orderBy: [
    id,
    payerId,
    userId,
    payeeId,
    status,
    foreverOffOn,
    deliver,
    frequency,
  ],
});
